import { betTypesNames } from '../enums/betTypes';

const oddProb = [0, 0.08, 0.16, 0.24, 0.32, 0.4, 0.48, 0.56, 0.64, 0.72, 0.8, 0.88];
const reversOddProb = [...oddProb].reverse();

const handleRtp = (market, hiOddProbIndex, loOddProbIndex) => {
  if (market.hiOrLo === 0) {
    return market.odd * reversOddProb[hiOddProbIndex] * 100;
  }
  if (market.hiOrLo === 1) {
    return market.odd * oddProb[loOddProbIndex] * 100;
  }
  return null;
};

const handleBetType = (market) => {
  if (market?.hiOrLo === 0) {
    return 'HIGH';
  }
  if (market?.hiOrLo === 1) {
    return 'LO';
  }
  return null;
};

export const updatedMarkets = (markets) => {
  let loOddProbIndex = 0;
  let hiOddProbIndex = -1;
  const gameConfig = markets.map((market) => {
    if (market.hiOrLo === 1 || market.hiOrLo === 0) {
      if (market.hiOrLo === 0) {
        hiOddProbIndex += 1;
      } else if (market.hiOrLo === 1) {
        loOddProbIndex += 1;
      }
      return {
        ...market,
        betType: handleBetType(market),
        rtp: handleRtp(market, hiOddProbIndex, loOddProbIndex),
      };
    }
    return market;
  });
  return gameConfig;
};

export const handleRtpTableData = (allMarkets, setCorrectBetTypes) => {
  const betTypesByName = {};
  allMarkets
    .filter((item) => item.hiOrLo !== null)
    .forEach((item) => {
      const name = item.name.split('_')[1];
      if (betTypesByName[name]) {
        betTypesByName[name][item.betType] = item;
      } else {
        betTypesByName[name] = {};
        betTypesByName[name][item.betType] = item;
      }
    });
  const result = Object.keys(betTypesByName).map((name) => {
    return {
      type: name,
      lo: betTypesByName[name].LO?.odd || '-',
      hi: betTypesByName[name].HIGH?.odd || '-',
      rtpLo: betTypesByName[name].LO?.rtp ? `${betTypesByName[name].LO?.rtp}%` : '-',
      rtpHi: betTypesByName[name].HIGH?.rtp ? `${betTypesByName[name].HIGH?.rtp}%` : '-',
    };
  });
  setCorrectBetTypes(result);
};

export const groupedBetTableData = (allMarkets) => {
  const keys = Object.keys(betTypesNames);
  return allMarkets?.reduce((acc, curr) => {
    if (keys.some((item) => curr.name === item)) {
      acc.push({
        name: betTypesNames[curr.name],
        odd: curr.odd,
      });
    }
    return acc.sort((firsValue, secondValue) => {
      return firsValue.odd - secondValue.odd;
    });
  }, []);
};
